import { action, makeObservable, observable } from "mobx";
import BaseService from "../base/BaseService";

/**
 * Container for the Thank you page data.
 */
class ThankYouService extends BaseService {
	@observable
	thankYouData = null;

	constructor(props) {
		super(props);
		makeObservable(this);
	}

	@action
	setThankYouData = (data) => {
		this.thankYouData = data;
	};
}

export default ThankYouService;
